module.exports = __webpack_public_path__ + "img/logo.9cdc52f9.png";